import * as userStorageService from '../services/user-storage-service';

const STORAGE_KEY = 'flyout';

export const fetchFlyoutConfig = () => {
    return userStorageService.get(STORAGE_KEY);
}

export const openFlyout = (flyoutId, flyoutProps) => {
    const config = userStorageService.get(STORAGE_KEY) || {};
    userStorageService.set(STORAGE_KEY, Object.assign({}, config, {
        activeId: flyoutId,
        flyoutProps: flyoutProps
    }));
}

export const closeFlyout = () => {
    const config = userStorageService.get(STORAGE_KEY) || {};
    userStorageService.set(STORAGE_KEY, Object.assign({}, config, {
        activeId: null,
        flyoutProps: null
    }));
}
